export default __webpack_public_path__ + "static/media/moki@2x.093f0de3.png";